import { IsOptional, IsString, Length } from 'class-validator';

export class ManufacturerModel {
  @IsString()
  @Length(2, 128)
  public name: string;

  @IsOptional()
  @IsString()
  @Length(32, 36)
  public id?: string;

  constructor(name: string, id?: string) {
    this.name = name;
    this.id = id;
  }
}
